import { Button, Flex, Form, Input, Spin ,message } from 'antd'
import React, { useState } from 'react'
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import api from '../api';

function ChangePassword() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();



   const onFinish = async (values) => {
    const session = JSON.parse(localStorage.getItem("session"));
    const storedPassword = session?.password;


   

    // Validate old password
    if (values.oldPassword !== storedPassword) {
        messageApi.error("Old password is incorrect");
        return;
    }

    // Prevent using same password
    if (values.oldPassword === values.newPassword) {
        messageApi.error("New password cannot be same as old password");
        return;
    }

    // Validate confirm password
    if (values.newPassword !== values.confirmPassowrd) {
        messageApi.error("New password and Confirm password must match");
        return;
    }

    try {
        setLoading(true);

        const requestData = {
            synceddatetime: "2025-05-29 10:08:00",
            FormCode: "201",
            AppVersion: "1.0.0.0",
            ApiKey: "kavin",
            AppTypeNo: "3",
            fld_rf_id: "1",    
            fld_old_password: values.oldPassword,
            fld_new_password: values.newPassword,
            fld_user_id: "admin"
        };



        const response = await api.ChangePassword(requestData);

        if (response.data.status === "1") {
            messageApi.success("Password changed successfully");
           
            localStorage.removeItem("session");
             setTimeout(()=>{
                navigate('/')

            },[2000])

        } else {
            messageApi.error(response.data.message || "Password change failed");
        }
    } catch (err) {
        console.error(err);
        messageApi.error("Something went wrong");
    } finally {
        setLoading(false);
    }
};


    return (
        <div className="login-page">
            {contextHolder}
            <Spin spinning={loading}>
                <div className="logo-wrapper">
                    <img src="/Logo.png" alt="App Logo" className="login-logo" />
                </div>
                <div className="login-container">
                    <h2 className="login-title">Change Password</h2>
                    <p className="login-subtitle">
                        Please enter your Old Password, New password and Confirm New Password to change your password
                    </p>
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        className="login-form"
                        initialValues={{ remember: false }}
                    >
                        <Form.Item
                            label="Old Password"
                            name="oldPassword"
                            rules={[
                                { required: true, message: "Old Password is required" }
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Enter your Old Password"
                            />
                        </Form.Item>

                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            rules={[{ required: true, message: "New Password is required" }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="New Password"
                            />
                        </Form.Item>
                        <Form.Item
                            label="Confirm New Password"
                            name="confirmPassowrd"
                            rules={[{ required: true, message: "Confirm Password is required" }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Confirm New Password"
                            />
                        </Form.Item>
                        <Flex justify='space-around'>
                            <Form.Item className="signIn-button">
                                <Button type="primary" htmlType="submit" className='change-button' >
                                    Change
                                </Button>

                            </Form.Item>
                            <Button type="primary" className='change-button' onClick={() => navigate(-1)}>
                                Cancel
                            </Button>
                        </Flex>
                    </Form>
                </div>
            </Spin>
        </div>

    )
}

export default ChangePassword